import { ACTIVITY_TYPE } from '../../constants/wallaroo.constants';

export const getModelActivityData = ({
  comments,
  currentUser,
}) => {
  const activityData = [];

  if (comments && comments.length) {
    comments?.forEach((comment) => {
      activityData.push({
        id: comment.id,
        type: ACTIVITY_TYPE.COMMENT,
        eventDate: comment.created_at,
        content: comment,
        currentUser,
      })
    });
  }

  return activityData.length ? activityData : comments ? [] : null;
}

export const getPipelineActivityData = ({
  comments,
  currentUser,
}) => {
  const activityData = [];

  if (comments && comments.length) {
    comments?.forEach((comment) => {
      activityData.push({
        id: comment.id,
        type: ACTIVITY_TYPE.COMMENT,
        eventDate: comment.created_at,
        content: comment,
        currentUser,
      })
    });
  }

  return activityData.length ? activityData : comments ? [] : null;
}
